<template>
  <Layout>
    <PageHeader :items="items" />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Formularios Asignados</span>
        <span>
          <Network v-slot="status">
            <b-button
              v-if="status.isOnline && getCountQueuedSessions() > 0"
              variant="primary"
              pill
              @click="syncData"
            >
              Sincronizar datos
              <b-badge
                v-if="getCountQueuedSessions() > 0"
                variant="warning"
                pill
                >{{ getCountQueuedSessions() }}</b-badge
              >
            </b-button>
          </Network>
          <!-- <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'home' }"
          >
            <b-icon
              class="icon-plus"
              icon="arrow90deg-left"
            ></b-icon>
          </router-link> -->
        </span>
      </div>
      <div class="card-app">
        <b-overlay
          :show="isSaving"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-xxl-12 col-md-12 p-0 mr-0 ml-0">
              <BaseDatatable
                ref="table"
                :drfprovider="getFormData"
                :tableheaders="fields"
                :perpage="10"
                emptyText="No tiene formularios Asignados"
              >
                <template #head(actions)>
                  <span class="title-actions d-flex justify-content-center"
                    >Acciones</span
                  >
                  <div class="d-flex content-actions">
                    <span>Diligenciar</span>
                    <span>Reporte</span>
                  </div>
                </template>
                <template v-slot:cell(title)="row">
                  <b-badge
                    v-if="getCountQueuedSessions(row.item.id) > 0"
                    variant="warning"
                    pill
                    class="mr-2"
                    >{{ getCountQueuedSessions(row.item.id) }}</b-badge
                  >
                  {{ row.item.form.title }}
                </template>
                <template v-slot:cell(pub_state)="row">{{
                  pubStates.find((x) => x.id === row.item.form.pub_state).text
                }}</template>
                <!-- 
              <template v-slot:cell(meta__modified_at)="row">{{ row.item.form.meta.modified_at }}</template> 
              -->
                <template v-slot:cell(actions)="row">
                  <b-button-group size="xs d-flex">
                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="btn-link btn-hover text-info btn-transparent"
                      size="xs"
                      :disabled="row.item.form.pub_state !== 'P'"
                      @click="
                        $router.push({
                          name: 'formFill',
                          params: { formId: row.item.id },
                        })
                      "
                    >
                      <b-icon-list-check
                        font-scale="1.8"
                      ></b-icon-list-check>
                    </b-button>
                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="btn-link btn-hover text-info btn-transparent"
                      size="xs"
                      :disabled="row.item.form.pub_state !== 'P'"
                      @click="
                        showSummary({
                          id: row.item.form.id,
                          title: row.item.form.title,
                        })
                      "
                    >
                      <b-icon-card-checklist
                        font-scale="1.8"
                      ></b-icon-card-checklist>
                    </b-button>
                  </b-button-group>
                </template>
              </BaseDatatable>
            </div>

            <!-- <div>
          Forms: {{ forms_cached.results.length }}<br>
          Dimensions: {{ dimensions_cached.results.length }}<br>
          Sessions: {{ sessions_cached.length }}
      </div> -->
          </div>
        </b-overlay>
      </div>
    </div>

    <b-modal
      v-model="modal_summary"
      :title="modal_title"
      size="lg"
      class="p-0"
      ok-only
      ok-title="Cerrar"
      ok-variant=""
      scrollable
    >
      <table
        class="table b-table table-striped table-sm m-0"
        v-if="typeof summary_sessions !== 'string'"
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Estado</th>
            <th>Key</th>
            <!-- <th>Fecha Inicio</th> -->
            <!-- <th>Fecha Fin</th> -->
            <th>Guardado</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="session in summary_sessions"
            :key="session.key"
            :class="{ 'text-danger': !session.state }"
          >
            <td>{{ session.id || '-' }}</td>
            <td>{{
              sessionStates.find((x) => x.id === (session.state || '')).text
            }}</td>
            <td>{{ session.key }}</td>
            <!-- <td>{{ session.start_time ? $strfDatetime(session.start_time) : '-' }}</td> -->
            <!-- <td>{{ session.end_time ? $strfDatetime(session.end_time) : 'No finalizado' }}</td> -->
            <td>{{ session.modified_at ? session.modified_at : '-' }}</td>
          </tr>
        </tbody>
      </table>
      <p v-if="!networkState.isOnline" class="text-warning pt-3">
        No hay conexión a Internet. Solo se muestran los registros locales (sin
        sincronizar)
      </p>
      <span v-else-if="typeof summary_sessions === 'string'">{{
        summary_sessions
      }}</span>
    </b-modal>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { formMethods, variablesMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import { encrypt, decrypt } from '@utils/local-storage'
import Network, { networkState } from '@plugins/Network'

export default {
  page: {
    title: 'Lista de Formularios',
  },
  components: { Layout, PageHeader, BaseDatatable, Network, networkState },
  data() {
    return {
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Lista de Formularios',
          active: true,
        },
      ],
      fields: [
        // { key: 'id', label: 'ID', sortable: true },
        { key: 'title', label: 'Nombre del Formulario', sortable: true },
        // { key: 'pub_version', label: 'Version', sortable: true},
        { key: 'pub_state', label: 'Estado', sortable: true },
        // { key: 'managers', label: 'Gestores', sortable: true},
        // { key: 'meta__modified_at', label: 'Fecha modificación', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      pubStates: [
        { id: '', text: 'Sin guardar' },
        { id: 'N', text: 'No Publicado' },
        { id: 'P', text: 'Publicado' },
        { id: 'X', text: 'Pausado' },
      ],
      sessionStates: [
        { id: '', text: 'Sin guardar' },
        { id: 'C', text: 'Creado' },
        { id: 'F', text: 'Finalizado' },
        { id: 'E', text: 'Eliminado' },
      ],
      isSaving: false,
      dimensions_cached: '' || [],
      forms_cached: '' || [],
      sessions_cached: '' || [],
      modal_summary: false,
      modal_title: '',
      summary_sessions: [],
      extraButtons: [
        {
          variant: 'info',
          title: 'Inicio',
          to: { name: 'home' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  mounted() {
    this.dimensions_cached = this.getSavedState('dimensions_cached')
    this.forms_cached = this.getSavedState('forms_cached')
    this.sessions_cached = this.getSavedState('sessions_cached')
    if (Object.keys(this.dimensions_cached).length === 0) {
      this.getDimensions('?page_size=999')
    }
    if (
      'setAppBadge' in window.navigator &&
      'clearAppBadge' in window.navigator
    ) {
      //use the native badge API
      let forms = this.sessions_cached.length
      if (forms > 0) {
        window.navigator.setAppBadge(forms).catch((error) => {
          console.error('error badge:', error)
        })
      } else {
        window.navigator.clearAppBadge().catch((error) => {
          console.error('error clean badge:', error)
        })
      }
    }
  },
  methods: {
    ...formMethods,
    ...variablesMethods,

    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno = JSON.parse(this.getStateLocalStorage(key))
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return '[]'
      }
    },
    getCountQueuedSessions(formId) {
      if (formId) {
        return this.sessions_cached.filter(
          (x) => parseInt(x.form) == parseInt(formId)
        ).length
      }
      return this.sessions_cached.length
    },

    getQueuedSessions(formId) {
      if (formId) {
        return this.sessions_cached.filter(
          (x) => parseInt(x.form) == parseInt(formId)
        )
      }
      return this.sessions_cached
    },

    getFormData(ctx) {
      if (window.navigator.onLine) {
        const promise = this.getFormsManaged(
          this.$table_params(ctx) + '&form_list=true'
        )
        return promise
          .then((data) => {
            // console.log('ayudaaa', data)

            return data
          })
          .catch((error) => {
            console.log(
              'Se presento un error en la carga de los formularios.',
              error
            )
          })
      } else if (Object.keys(this.forms_cached).length > 0) {
        const promise = new Promise((resolve, reject) => {
          resolve(this.forms_cached)
        })
        return promise
          .then((data) => {
            return data
          })
          .catch((error) => {
            console.log(
              'Se presento un error en la carga de los formularios (offline).',
              error
            )
          })
      } else {
        _.$generate_noty('warn', `Sin conexión a Internet, intente nuevamente`)
      }
    },

    showSummary(form) {
      this.modal_summary = true
      this.modal_title = form.title
      this.summary_sessions = 'Espere...'
      this.getSummary(form.id).then((data) => {
        this.summary_sessions = data
      })
    },

    async getSummary(formId) {
      let sessions = []
      const queued_sessions = this.getQueuedSessions(formId)
      if (queued_sessions.length > 0) {
        sessions = queued_sessions.map((x) => {
          return {
            id: x.id,
            key: x.key,
            state: x.state,
            start_time: x.start_time,
            end_time: x.end_time,
          }
        })
      }
      if (this.networkState.isOnline) {
        await this.getFormSessions(formId)
          .then((data) => {
            sessions = sessions.concat(
              data.results.map((x) => {
                return {
                  id: x.id,
                  key: x.key,
                  state: x.state,
                  start_time: x.start_time,
                  end_time: x.end_time,
                  modified_at: Object(x.meta).hasOwnProperty('modified_at')
                    ? x.meta.modified_at
                    : null,
                }
              })
            )
          })
          .catch((error) => {
            console.log(error)
          })
      }
      return sessions
    },

    syncData() {
      let _ = this
      const queued_sessions = this.getCountQueuedSessions()
      if (queued_sessions > 0) {
        this.sessions_cached.forEach((session) => {
          session.mode = 'sync'
          _.isSaving = true
          const promise = this.setFormSession({ ...session })
          return promise
            .then((data) => {
              _.isSaving = false
              let msg_queue = ''
              if (data.queue_sessions > 0) {
                msg_queue = `<br><i><small>Restan ${
                  data.queue_sessions
                } de ${queued_sessions}</small></i>`
              } else {
                _.$generate_noty('success', `Sincronización finalizada!`)
                this.sessions_cached = this.getSavedState('sessions_cached')
              }
              if (data.id) {
                _.$generate_noty(
                  'success',
                  `Formulario #${
                    data.id
                  } sincronizado correctamente ${msg_queue}`
                )
              } else {
                _.$generate_noty(
                  'warn',
                  `Formulario no sincronizado, verifique su conexión a Internet ${msg_queue}`
                )
              }
            })
            .catch((error) => {
              _.isSaving = false
              _.$generate_noty('error', error)
              console.log(
                'Se presento un error al guardar el formulario',
                error
              )
            })
        })
      }
    },
  },
  computed: {
    networkState,
  },
}
</script>
